import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

const LOADING_MESSAGES = [
  '👋 Still here. Sorry about the delay.',
  "😊 Hang tight, we're on it!",
  '😌 Just a moment, please.',
  '🤔 Still thinking, thanks for your patience.',
  '😎 Almost there, stay with us!',
  '🙃 Working on it, please hold on.',
  "😇 Thanks for waiting, we're still here.",
  '🤓 Still processing, bear with us.',
  '😌 Gathering info, almost done.',
  '😅 Just a bit longer, still here.',
  '😴 Compiling info, please wait.',
  '😌 Stay tuned, still working.',
  '🤓 One sec, still processing.',
  '🤯 Gathering insights, almost done.',
  '🧐 Calculating, thanks for your patience.',
  '😇 Hold tight, still working.',
  '👋 Still thinking...',
  '🙏 Please wait, still processing.',
];

const LoadingContainer = () => {
  const [currentMessage, setCurrentMessage] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const newMessage = LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)];
      setCurrentMessage(newMessage);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentMessage]);

  return (
    <Grid className="bp-flex !bp-flex-col bp-items-center" item>
      <CircularProgress sx={{ margin: 10 }} />
      {Boolean(currentMessage) && <span className="bp-font-primary-small">{currentMessage}</span>}
    </Grid>
  );
};

export default LoadingContainer;
